export default __webpack_public_path__ + "static/cv-catalog-26ca11236ea7aaf7156c8bc60aae6fe8.svg";